export default __webpack_public_path__ + "static/media/bomb-pepe.ab6aa206.jpeg";